import React from "react";
// import icon1 from "../../icons/icon-coin.svg";
import WalletIcon from "../../images/coin/wallet-coin.png";
import Coin from "../../images/coin/coin.png";
const featuresData = [
  {
    icon: WalletIcon,
    title: "Titanium",
    description: "1 to 19,999 Units, Value £ 0-99.99",
  },
  {
    icon: WalletIcon,
    title: "Bronze",
    description:
      "20,000 to 199,999 Units Value £100-£ 999.99",
  },
  {
    icon: WalletIcon,
    title: "Nickel",
    description:
      "200,000-1,999,999 Units Value: £1,000-£9,999.99",
  },
  {
    icon: WalletIcon,
    title: "Silver",
    description:
      "200,0000-9,999,999 Units, Value: £10,000-49,999.99",
  },
  {
    icon: WalletIcon,
    title: "Palladium",
    description:
      "10,000,000-19,999,999 Units, Value: £50,000-£99,999.99",
  },
  {
    icon: WalletIcon,
    title: "Gold",
    description: "20,000,000-Unlimited Units, Value £100,000- Unlimited",
  },
];

const CashData = [
  {
    icon: Coin,
    title: "-",
    description: "-",
  },
  {
    icon: Coin,
    title: "Cash Wallet 1",
    description:
      "£25.00 (Current Value)",
  },
  {
    icon: Coin,
    title: "Cash Wallet 2",
    description:
      "£ ***.**",
  },
  {
    icon: Coin,
    title: "Cash Wallet 3",
    description:
      "£ *****.**",
  },
  {
    icon: Coin,
    title: "Cash Wallet 4",
    description:
      "£ ******.**",
  },
  {
    icon: Coin,
    title: "Cash Wallet 5",
    description: "£ ******.**",
  },
];

const MyWallet = () => {
  // const ClickHandler = () => {
  //   window.scrollTo(10, 0);
  // };

  return (
    <section
      id="id_ico_tokenomics_section"
      className="ico_tokenomics_section bg-light-subtle section_space pb-5"
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-6">
            <div className="row">
              <div className="text-center">
                <h2 className="text-dark d-flex flex-column opacity-75">
                 
                  TopCoin UK Units Wallets{" "}
                  <div className=" text-center">
                     <img src={Coin} width={100} alt=""/>
                 
                   </div>
                </h2>
              </div>
              {featuresData.map((feature, index) => (
                <div className="col-lg-12 position-relative wallet-box z-1 ">
                  <ul className="ico_features_group unordered_list_block">
                    <li
                      key={index}
                      data-aos="fade-up"
                      data-aos-duration="600"
                      data-aos-delay={100 * (index + 1)}
                    >
                      <div className="ico_iconbox_icon_left d-flex min-h200 flex-lg-nowrap justify-content-center justify-content-lg-start flex-wrap shadow-sm align-items-center">
                        {/* <div className="iconbox_icon icon-100 text-center">
                          <img src={feature.icon} alt={feature.title} />
                        </div> */}
                        <div className="iconbox_info text-start">
                          <h3 className="iconbox_title">{feature.title}</h3>
                          <p className="iconbox_description text-dark mb-0">
                            {feature.description}
                          </p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              ))}
            </div>
          </div>
          <div className="col-lg-6 col-6">
            <div className="row  rounded-3">
              <div className="text-center">
                 <h2 className="text-dark d-flex flex-column opacity-75">
                 
                  TopCoin UK Cash Wallets{" "}
                  <div className=" text-center">
                    <img src={WalletIcon} width={100} alt=""/>
                   </div>
                </h2>
              
              </div>

              {CashData.map((feature, index) => (
                <div className="col-lg-12 position-relative wallet-box z-1 ">
                  <ul className="ico_features_group unordered_list_block">
                    <li
                      key={index}
                      data-aos="fade-up"
                      data-aos-duration="600"
                      data-aos-delay={100 * (index + 1)}
                    >
                      <div className="ico_iconbox_icon_left d-flex min-h200  flex-lg-nowrap justify-content-center justify-content-lg-start flex-wrap  shadow-sm align-items-center">
                        {/* <div className="iconbox_icon icon-100 text-center">
                          <img src={feature.icon} alt={feature.title} />
                        </div> */}
                        <div className="iconbox_info text-start">
                          <h3 className="iconbox_title">{feature.title}</h3>
                          <p className="iconbox_description text-dark mb-0">
                            {feature.description}
                          </p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MyWallet;
